module.exports = __webpack_public_path__ + "img/analytics_bf3a930.webp";